import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { ScarcityHeader } from '../components/ScarcityHeader';
import { MainHeadline } from '../components/MainHeadline';
import { PricingBlock } from '../components/PricingBlock';
import { ProductImage } from '../components/ProductImage';
import { ValueStack } from '../components/ValueStack';
import { HotmartFunnel } from '../components/HotmartFunnel';
import { SocialProof } from '../components/SocialProof';
import { TrustBadges } from '../components/TrustBadges';
export function Downsell() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 pb-0" data-id="element-76">
      <AnnouncementBar data-id="element-77" />
      <ScarcityHeader data-id="element-78" />

      <main className="max-w-2xl mx-auto px-4 sm:px-6 flex flex-col gap-8 md:gap-12 pt-8 md:pt-12" data-id="element-79">
        <MainHeadline data-id="element-80" />
        <PricingBlock data-id="element-81" />
        <ProductImage data-id="element-82" />
        <ValueStack data-id="element-83" />
        <HotmartFunnel data-id="element-84" />
        <SocialProof data-id="element-85" />
      </main>

      <TrustBadges data-id="element-86" />
    </div>;
}